import React, { useRef } from "react";
import { NotificationManager } from "react-notifications";
import { Controller, useForm } from "react-hook-form";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import AsyncSelect from "react-select/lib/Async";
import moment from "moment";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";
import { NumberField } from "../../../../../../Utils/renderField/fieldsHookForms";

export const FormBultosSkim = ({ bultosSkimApi, RefreshData }) => {
    // formulario
    const {
        control: formControl,
        formState: { errors: formErrors },
        getValues: formGetValues,
        setValue: formSetValue,
        watch,
        trigger: validateForm,
    } = useForm({
        mode: "onChange",
    });

    const { agregarBultoSkim, getAlmacenesSkim } = bultosSkimApi;

    const AgregarBulto = async () => {
        try {
            const isValid = await validateForm();
            if (!isValid) {
                return;
            }

            const almacen = formGetValues("almacen");
            const kg_humedos = formGetValues("kg_humedos");

            const data = {
                almacen_id: almacen.id,
                kg_humedos_original: kg_humedos,
                kg_humedos_actual: kg_humedos,
            };

            await agregarBultoSkim(data);

            NotificationManager.success(
                "Bulto agregado correctamente",
                "Éxito",
                3000,
            );

            // Limpiar campos del formulario
            formSetValue("almacen", null);
            formSetValue("kg_humedos", null);

            hasAutoSelected.current = false;

            RefreshData();
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al agregar bulto skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const loadAlmacenes = useDebouncedAsyncSelect(function (search) {
        return getAlmacenesSkim({ search: search });
    });

    const hasAutoSelected = useRef(false);

    return (
        <div className="formulario-fields-row">
            <div className="formulario-field">
                <label className="text-nowrap">Almacén</label>
                <Controller
                    name="almacen"
                    control={formControl}
                    rules={{
                        required: "Debe seleccionar un Almacén",
                    }}
                    render={({ field }) => (
                        <AsyncSelect
                            {...field}
                            className="react-select-container"
                            isSearchable
                            isClearable
                            defaultOptions
                            loadOptions={loadAlmacenes}
                            getOptionValue={(option) => option.id}
                            getOptionLabel={(option) => option.nombre}
                            onChange={(selected) => {
                                field.onChange(selected);
                            }}
                        />
                    )}
                />
                {formErrors.almacen && (
                    <small className="text-danger">
                        {formErrors.almacen.message}
                    </small>
                )}
            </div>

            <div className="formulario-field">
                <label className="text-nowrap">Peso del bulto</label>
                <NumberField
                    control={formControl}
                    name="kg_humedos"
                    errors={formErrors}
                    allowNegative={false}
                    suffix=" Kg"
                    rules={{
                        required: "Este campo es obligatorio",
                        min: {
                            value: 1,
                            message: "Debe ser al menos 1",
                        },
                    }}
                    decimalScale={2}
                />
            </div>

            <div className="formulario-field" style={{ minWidth: "33%" }}>
                <button
                    className="btn btn-primary"
                    style={{ marginTop: "26px" }}
                    onClick={AgregarBulto}
                >
                    Agregar bulto
                </button>
            </div>
        </div>
    );
};
